import { render, staticRenderFns } from "./ResponseTable.vue?vue&type=template&id=72625c2c&scoped=true&"
import script from "./ResponseTable.vue?vue&type=script&lang=js&"
export * from "./ResponseTable.vue?vue&type=script&lang=js&"
import style0 from "./ResponseTable.vue?vue&type=style&index=0&id=72625c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72625c2c",
  null
  
)

export default component.exports